interface INextRoute {
    isEditing: boolean
    router: any
}

async function determineNextRouteAndPush({ isEditing, router }: INextRoute) {
    if (isEditing) {
        const pathWithoutUrlParams: string = router.asPath.split('?')[0]
        await router.push(pathWithoutUrlParams)
    }
    await router.reload()
}

export default determineNextRouteAndPush
